import { useState, useEffect } from 'react';
import API from '../utils/api';
import { useAuth } from '../context/AuthContext';
import ProductPicker from '../components/ProductPicker';

export default function BOM() {
  const { user } = useAuth();
  const [finishedProducts, setFinishedProducts] = useState([]);
  const [flavors, setFlavors] = useState([]);
  const [selectedFP, setSelectedFP] = useState(null);
  const [bomItems, setBomItems] = useState([]);

  // modals
  const [fpModal, setFpModal] = useState(false);
  const [flavorModal, setFlavorModal] = useState(false);
  const [bomModal, setBomModal] = useState(false);
  const [editFP, setEditFP] = useState(null);

  const [fpForm, setFpForm] = useState({ name:'', brand:'', product_type:'', description:'', unit:'pcs', price:0, visible_to_sales:true, unit_weight_kg:'', pieces_per_carton:'', carton_gross_weight_kg:'', carton_dimensions:'', cartons_per_pallet:'' });
  const [flavorForm, setFlavorForm] = useState('');
  const [bomForm, setBomForm] = useState({ flavor_id:'', raw_material_id:'', quantity_per_unit:1, notes:'' });
  const [brands, setBrands] = useState([]);
  const [filterBrand, setFilterBrand] = useState('');
  const [error, setError] = useState('');

  const load = () => {
    API.get('/finished-products').then(r => {
      setFinishedProducts(r.data);
      const b = [...new Set(r.data.map(p => p.brand).filter(Boolean))].sort();
      setBrands(b);
    });
    API.get('/flavors').then(r => setFlavors(r.data));
  };

  const loadBOM = (fp) => {
    setSelectedFP(fp);
    API.get(`/bom/${fp.id}`).then(r => setBomItems(r.data));
  };

  useEffect(() => { load(); }, []);

  const saveFP = async () => {
    setError('');
    if (!fpForm.name) return setError('الاسم مطلوب');
    // تأكد إن visible_to_sales رقم صريح
    const payload = {
      ...fpForm,
      visible_to_sales: fpForm.visible_to_sales ? 1 : 0,
      price: +fpForm.price || 0,
      unit_weight_kg: fpForm.unit_weight_kg !== '' ? +fpForm.unit_weight_kg : null,
      pieces_per_carton: fpForm.pieces_per_carton !== '' ? +fpForm.pieces_per_carton : null,
      carton_gross_weight_kg: fpForm.carton_gross_weight_kg !== '' ? +fpForm.carton_gross_weight_kg : null,
      cartons_per_pallet: fpForm.cartons_per_pallet !== '' ? +fpForm.cartons_per_pallet : null,
    };
    try {
      if (editFP) await API.put(`/finished-products/${editFP.id}`, payload);
      else await API.post('/finished-products', payload);
      setFpModal(false); setEditFP(null); setError(''); load();
    } catch(e) { setError(e.response?.data?.error || e.message || 'خطأ غير معروف'); }
  };

  const saveFlavor = async () => {
    if (!flavorForm.trim()) return;
    try {
      await API.post('/flavors', { name: flavorForm.trim() });
      setFlavorForm(''); load();
    } catch(e) { alert(e.response?.data?.error || 'حدث خطأ'); }
  };

  const deleteFlavor = async (id) => {
    if (!window.confirm('حذف هذه الرائحة؟')) return;
    try {
      await API.delete(`/flavors/${id}`);
      load();
    } catch(e) { alert(e.response?.data?.error || 'حدث خطأ'); }
  };

  const addBOMItem = async () => {
    if (!bomForm.raw_material_id || !bomForm.quantity_per_unit) return setError('اختر المادة والكمية');
    try {
      await API.post('/bom', { ...bomForm, finished_product_id: selectedFP.id, flavor_id: bomForm.flavor_id || null });
      setBomModal(false); setBomForm({ flavor_id:'', raw_material_id:'', quantity_per_unit:1, notes:'' });
      loadBOM(selectedFP);
    } catch(e) { setError(e.response?.data?.error || 'خطأ'); }
  };

  const deleteBOMItem = async (id) => {
    await API.delete(`/bom/${id}`);
    loadBOM(selectedFP);
  };

  const deleteFP = async (fp) => {
    if (!window.confirm(`حذف المنتج "${fp.name}" نهائياً؟\nسيتم حذف وصفته كاملة.\nلا يمكن التراجع.`)) return;
    try {
      await API.delete(`/finished-products/${fp.id}`);
      setSelectedFP(null); setBomItems([]); load();
    } catch(e) { alert(e.response?.data?.error || 'حدث خطأ'); }
  };

  const deleteFullBOM = async (flavorId = null) => {
    const label = flavorId
      ? flavors.find(f=>f.id===+flavorId)?.name || 'هذه الرائحة'
      : 'المنتج الأساسي';
    if (!window.confirm(`حذف وصفة "${label}" كاملة؟ لا يمكن التراجع.`)) return;
    const url = `/bom/product/${selectedFP.id}${flavorId ? `?flavor_id=${flavorId}` : ''}`;
    await API.delete(url);
    loadBOM(selectedFP);
  };

  const updateStockQty = async (fp, newQty) => {
    try {
      await API.put(`/finished-products/${fp.id}`, {
        name: fp.name, brand: fp.brand||'', product_type: fp.product_type||'',
        description: fp.description||'', unit: fp.unit||'pcs',
        price: fp.price||0, visible_to_sales: fp.visible_to_sales ? 1 : 0,
        unit_weight_kg: fp.unit_weight_kg||null, pieces_per_carton: fp.pieces_per_carton||null,
        carton_gross_weight_kg: fp.carton_gross_weight_kg||null,
        carton_dimensions: fp.carton_dimensions||'', cartons_per_pallet: fp.cartons_per_pallet||null,
        stock_qty: +newQty || 0
      });
      setSelectedFP(prev => ({ ...prev, stock_qty: +newQty || 0 }));
      load();
    } catch(e) { alert('خطأ في تحديث المخزون'); }
  };

  const commonItems = bomItems.filter(b => !b.flavor_id);
  const flavorItems = bomItems.filter(b => b.flavor_id);
  const flavorGroups = {};
  flavorItems.forEach(b => {
    if (!flavorGroups[b.flavor_name]) flavorGroups[b.flavor_name] = [];
    flavorGroups[b.flavor_name].push(b);
  });

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">⚗️ وصفات الإنتاج (BOM)</h1>
        <div className="page-actions">
          <button className="btn btn-secondary" onClick={() => setFlavorModal(true)}>🌸 إدارة الروائح</button>
          <button className="btn btn-primary" onClick={() => { setEditFP(null); setFpForm({ name:'', brand:'', product_type:'', stock_qty:0, description:'', unit:'pcs', price:0, visible_to_sales:true }); setError(''); setFpModal(true); }}>+ منتج نهائي</button>
        </div>
      </div>

      {/* Flavors Modal */}
      {flavorModal && (
        <div className="modal-overlay" onClick={() => setFlavorModal(false)}>
          <div className="modal" style={{ maxWidth: 440 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-title">🌸 إدارة الروائح</span>
              <button className="modal-close" onClick={() => setFlavorModal(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
                <input value={flavorForm} onChange={e => setFlavorForm(e.target.value)} placeholder="اسم الرائحة (مانغو، روز...)" onKeyDown={e => e.key === 'Enter' && saveFlavor()} style={{ flex: 1 }} />
                <button className="btn btn-primary" onClick={saveFlavor}>+ إضافة</button>
              </div>
              <div style={{ maxHeight: 300, overflowY: 'auto' }}>
                {flavors.map(f => (
                  <div key={f.id} className="flex-between" style={{ padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
                    <span className="font-bold">{f.name}</span>
                    {user?.role === 'admin' && (
                      <button className="btn btn-sm btn-danger" onClick={() => deleteFlavor(f.id)}>حذف</button>
                    )}
                  </div>
                ))}
                {flavors.length === 0 && <p className="text-muted text-center">لا توجد روائح بعد</p>}
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setFlavorModal(false)}>إغلاق</button>
            </div>
          </div>
        </div>
      )}

      {/* Finished Product Modal */}
      {fpModal && (
        <div className="modal-overlay" onClick={() => setFpModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-title">{editFP ? 'تعديل منتج نهائي' : 'منتج نهائي جديد'}</span>
              <button className="modal-close" onClick={() => setFpModal(false)}>✕</button>
            </div>
            <div className="modal-body">
              {error && <div className="alert alert-error">{error}</div>}
              <div className="form-grid">
                <div className="form-group span-2"><label>اسم المنتج <span className="required">*</span></label><input value={fpForm.name} onChange={e => setFpForm({ ...fpForm, name: e.target.value })} placeholder="مثال: ريد ديفوزر 110مل" /></div>
                <div className="form-group"><label>الماركة</label>
                  <select value={fpForm.brand||''} onChange={e=>setFpForm({...fpForm,brand:e.target.value})}>
                    <option value="">-- اختر الماركة --</option>
                    {brands.map(b=><option key={b} value={b}>{b}</option>)}
                  </select>
                </div>
                <div className="form-group"><label>نوع المنتج</label>
                  <select value={fpForm.product_type||''} onChange={e=>setFpForm({...fpForm,product_type:e.target.value})}>
                    <option value="">-- اختر النوع --</option>
                    {['Reed Diffuser 110ml','Reed Diffuser 55ml','Reed Diffuser 120ml','Reed Diffuser 160ml','Car Perfume 8ml','Car Perfume 33ml','Room Spray 260ml','Room Spray 280ml','Room Spray 300ml','Room Spray 500ml','Car Air Freshener 50ml','AIR FRESHENER FOR CAR 30ml','Body Splash 230ml'].map(t=>(
                      <option key={t} value={t}>{t}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group span-2"><label>الوصف</label><input value={fpForm.description} onChange={e => setFpForm({ ...fpForm, description: e.target.value })} /></div>
                <div className="form-group"><label>الوحدة</label>
                  <select value={fpForm.unit} onChange={e => setFpForm({ ...fpForm, unit: e.target.value })}>
                    <option value="pcs">قطعة</option><option value="box">كرتون</option><option value="dozen">دزينة</option>
                  </select>
                </div>
                <div className="form-group"><label>سعر البيع</label><input type="number" value={fpForm.price} onChange={e => setFpForm({ ...fpForm, price: +e.target.value })} /></div>
                <div className="form-group span-2">
                  <label>ظهور المنتج لموظفي المبيعات</label>
                  <div style={{ display:'flex', gap:8 }}>
                    <button type="button"
                      onClick={() => setFpForm({...fpForm, visible_to_sales: true})}
                      style={{ flex:1, padding:'10px', borderRadius:8, border:'2px solid', cursor:'pointer', fontWeight:700, fontSize:'0.85rem',
                        borderColor: fpForm.visible_to_sales ? 'var(--success)' : 'var(--border)',
                        background: fpForm.visible_to_sales ? '#dcfce7' : '#f9fafb',
                        color: fpForm.visible_to_sales ? 'var(--success)' : 'var(--muted)' }}>
                      👁️ ظاهر
                    </button>
                    <button type="button"
                      onClick={() => setFpForm({...fpForm, visible_to_sales: false})}
                      style={{ flex:1, padding:'10px', borderRadius:8, border:'2px solid', cursor:'pointer', fontWeight:700, fontSize:'0.85rem',
                        borderColor: !fpForm.visible_to_sales ? 'var(--danger)' : 'var(--border)',
                        background: !fpForm.visible_to_sales ? '#fee2e2' : '#f9fafb',
                        color: !fpForm.visible_to_sales ? 'var(--danger)' : 'var(--muted)' }}>
                      🔒 مخفي
                    </button>
                  </div>
                </div>

                {/* حقول الباكينج */}
                <div className="form-group span-2" style={{ borderTop:'1px solid var(--border)', paddingTop:12, marginTop:4 }}>
                  <label style={{ fontWeight:700, color:'var(--primary)', fontSize:'0.85rem' }}>📦 بيانات الباكينج والشحن</label>
                </div>
                <div className="form-group">
                  <label>وزن القطعة (kg)</label>
                  <input type="number" step="0.001" value={fpForm.unit_weight_kg} onChange={e => setFpForm({...fpForm, unit_weight_kg: e.target.value})} placeholder="مثال: 0.35" />
                </div>
                <div className="form-group">
                  <label>قطع بالكرتونة</label>
                  <input type="number" value={fpForm.pieces_per_carton} onChange={e => setFpForm({...fpForm, pieces_per_carton: e.target.value})} placeholder="مثال: 12" />
                </div>
                <div className="form-group">
                  <label>وزن الكرتون الإجمالي (kg)</label>
                  <input type="number" step="0.01" value={fpForm.carton_gross_weight_kg} onChange={e => setFpForm({...fpForm, carton_gross_weight_kg: e.target.value})} placeholder="مثال: 5.2" />
                </div>
                <div className="form-group">
                  <label>أبعاد الكرتون (cm)</label>
                  <input value={fpForm.carton_dimensions} onChange={e => setFpForm({...fpForm, carton_dimensions: e.target.value})} placeholder="مثال: 40×30×25" />
                </div>
                <div className="form-group">
                  <label>كراتين / باليت</label>
                  <input type="number" value={fpForm.cartons_per_pallet} onChange={e => setFpForm({...fpForm, cartons_per_pallet: e.target.value})} placeholder="مثال: 182" />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={saveFP}>💾 حفظ</button>
              <button className="btn btn-secondary" onClick={() => setFpModal(false)}>إلغاء</button>
            </div>
          </div>
        </div>
      )}

      {/* Add BOM Item Modal */}
      {bomModal && selectedFP && (
        <div className="modal-overlay" onClick={() => setBomModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-title">➕ إضافة مادة للوصفة</span>
              <button className="modal-close" onClick={() => setBomModal(false)}>✕</button>
            </div>
            <div className="modal-body">
              {error && <div className="alert alert-error">{error}</div>}
              <div className="alert alert-info mb-2">المنتج: <strong>{selectedFP.name}</strong></div>
              <div className="form-grid">
                <div className="form-group span-2">
                  <label>الرائحة (اتركها فارغة للمواد المشتركة)</label>
                  <select value={bomForm.flavor_id} onChange={e => setBomForm({ ...bomForm, flavor_id: e.target.value })}>
                    <option value="">-- مشتركة (تنطبق على كل الروائح) --</option>
                    {flavors.map(f => <option key={f.id} value={f.id}>{f.name}</option>)}
                  </select>
                </div>
                <div className="form-group span-2">
                  <label>المادة الأولية <span className="required">*</span></label>
                  <ProductPicker
                    value={bomForm.raw_material_id}
                    onChange={p => { if(p) setBomForm({ ...bomForm, raw_material_id: p.id }); }}
                    placeholder="اختر المادة الأولية"
                  />
                </div>
                <div className="form-group"><label>الكمية لكل وحدة <span className="required">*</span></label><input type="number" value={bomForm.quantity_per_unit} onChange={e => setBomForm({ ...bomForm, quantity_per_unit: +e.target.value })} min={0.001} step={0.001} /></div>
                <div className="form-group"><label>ملاحظات</label><input value={bomForm.notes} onChange={e => setBomForm({ ...bomForm, notes: e.target.value })} /></div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={addBOMItem}>➕ إضافة</button>
              <button className="btn btn-secondary" onClick={() => setBomModal(false)}>إلغاء</button>
            </div>
          </div>
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: selectedFP ? '300px 1fr' : '1fr', gap: 20, alignItems: 'start' }}>
        {/* قائمة المنتجات النهائية */}
        <div style={{ position: 'sticky', top: 16, maxHeight: 'calc(100vh - 32px)', overflowY: 'auto', paddingInlineEnd: 4 }}>
          <div className="card-title mb-1" style={{ fontSize: '0.875rem', color: 'var(--muted)' }}>المنتجات النهائية</div>
          {/* فلتر الماركة */}
          <div style={{ marginBottom: 10, display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            <span onClick={() => setFilterBrand('')}
              style={{ padding: '3px 10px', borderRadius: 20, fontSize: '0.75rem', cursor: 'pointer', fontWeight: 700,
                background: filterBrand === '' ? 'var(--primary)' : 'var(--surface)',
                color: filterBrand === '' ? 'white' : 'var(--text)', border: '1px solid var(--border)' }}>
              الكل
            </span>
            {brands.map(b => (
              <span key={b} onClick={() => setFilterBrand(b)}
                style={{ padding: '3px 10px', borderRadius: 20, fontSize: '0.75rem', cursor: 'pointer', fontWeight: 700,
                  background: filterBrand === b ? 'var(--primary)' : 'var(--surface)',
                  color: filterBrand === b ? 'white' : 'var(--text)', border: '1px solid var(--border)' }}>
                {b}
              </span>
            ))}
          </div>
          {finishedProducts.filter(fp => !filterBrand || fp.brand === filterBrand).map(fp => (
            <div key={fp.id}
              onClick={() => loadBOM(fp)}
              style={{
                padding: '12px 16px', borderRadius: 10, marginBottom: 8, cursor: 'pointer',
                background: selectedFP?.id === fp.id ? 'var(--brand-light)' : 'white',
                border: `1.5px solid ${selectedFP?.id === fp.id ? 'var(--primary)' : 'var(--border)'}`,
                transition: 'all 0.15s'
              }}>
              <div className="flex-between">
                <span className="font-bold">{fp.name}</span>
                <span className={`badge ${fp.visible_to_sales ? 'badge-success' : 'badge-gray'}`} style={{ fontSize: '0.7rem' }}>
                  {fp.visible_to_sales ? '👁️ مرئي' : '🔒 مخفي'}
                </span>
              </div>
              <div style={{ display:'flex', gap:6, alignItems:'center', marginTop:4, flexWrap:'wrap' }}>
                {fp.brand && <span style={{ fontSize:'0.72rem', fontWeight:700, background:'var(--primary)', color:'white', borderRadius:20, padding:'1px 7px' }}>{fp.brand}</span>}
                <span className="text-muted" style={{ fontSize: '0.78rem' }}>{fp.bom_count} مادة في الوصفة</span>
                <span style={{ fontSize:'0.72rem', color: fp.stock_qty > 0 ? 'var(--success)' : 'var(--muted)' }}>
                  📦 {fp.stock_qty || 0}
                </span>
              </div>
              <button className="btn btn-sm btn-secondary" style={{ marginTop: 8 }}
                onClick={e => { e.stopPropagation(); setEditFP(fp); setFpForm({ name: fp.name, brand: fp.brand||'', product_type: fp.product_type||'', stock_qty: fp.stock_qty||0, description: fp.description||'', unit: fp.unit||'pcs', price: fp.price||0, visible_to_sales: fp.visible_to_sales===1||fp.visible_to_sales===true, unit_weight_kg: fp.unit_weight_kg||'', pieces_per_carton: fp.pieces_per_carton||'', carton_gross_weight_kg: fp.carton_gross_weight_kg||'', carton_dimensions: fp.carton_dimensions||'', cartons_per_pallet: fp.cartons_per_pallet||'' }); setError(''); setFpModal(true); }}>
                تعديل
              </button>
            </div>
          ))}
          {finishedProducts.length === 0 && (
            <div className="card text-center text-muted" style={{ padding: 20 }}>
              <div style={{ fontSize: '2rem' }}>📦</div>
              <p>لا توجد منتجات نهائية</p>
            </div>
          )}
        </div>

        {/* تفاصيل BOM */}
        {selectedFP && (
          <div style={{ position: 'sticky', top: 16, maxHeight: 'calc(100vh - 32px)', overflowY: 'auto', paddingInlineEnd: 4 }}>
            <div className="flex-between mb-2">
              <div>
                <h2 className="page-title" style={{ fontSize: '1.1rem' }}>⚗️ وصفة: {selectedFP.name}</h2>
                <span className="text-muted" style={{ fontSize: '0.85rem' }}>{bomItems.length} مادة إجمالاً</span>
                {/* حقل المخزون الحالي */}
                <div style={{ display:'flex', alignItems:'center', gap:8, marginTop:6 }}>
                  <span style={{ fontSize:'0.85rem', color:'var(--muted)' }}>📦 المخزون الجاهز:</span>
                  <input type="number" min={0}
                    key={selectedFP.id}
                    defaultValue={selectedFP.stock_qty || 0}
                    onBlur={e => { if(+e.target.value !== (selectedFP.stock_qty||0)) updateStockQty(selectedFP, e.target.value); }}
                    style={{ width:80, padding:'3px 8px', borderRadius:6, border:'1.5px solid var(--border)', fontSize:'0.85rem', textAlign:'center' }} />
                  <span style={{ fontSize:'0.78rem', color:'var(--muted)' }}>قطعة</span>
                </div>
                {selectedFP.pieces_per_carton && (
                  <div style={{ display:'flex', gap:10, marginTop:6, flexWrap:'wrap' }}>
                    {selectedFP.unit_weight_kg && <span className="badge badge-info">⚖️ {selectedFP.unit_weight_kg} kg/قطعة</span>}
                    <span className="badge badge-info">📦 {selectedFP.pieces_per_carton} قطعة/كرتون</span>
                    {selectedFP.carton_gross_weight_kg && <span className="badge badge-info">🏋️ {selectedFP.carton_gross_weight_kg} kg/كرتون</span>}
                    {selectedFP.carton_dimensions && <span className="badge badge-info">📐 {selectedFP.carton_dimensions}</span>}
                    {selectedFP.cartons_per_pallet && <span className="badge badge-info">🪵 {selectedFP.cartons_per_pallet} كرتون/باليت</span>}
                  </div>
                )}
              </div>
              <button className="btn btn-primary btn-sm" onClick={() => { setError(''); setBomModal(true); }}>+ إضافة مادة</button>
            </div>

            {/* المواد المشتركة */}
            <div className="card mb-2">
              <div className="flex-between">
                <div className="card-title">🔧 المواد المشتركة (لكل الروائح)</div>
                {user?.role==='admin' && commonItems.length > 0 && (
                  <button className="btn btn-sm btn-danger" onClick={() => deleteFullBOM(null)} title="حذف الوصفة المشتركة كاملة">🗑️ حذف الوصفة</button>
                )}
              </div>
              {commonItems.length === 0 ? (
                <p className="text-muted" style={{ fontSize: '0.875rem' }}>لا توجد مواد مشتركة</p>
              ) : (
                <table>
                  <thead><tr><th>التصنيف</th><th>المادة</th><th>الكمية لكل وحدة</th><th>متوفر</th><th>ملاحظات</th><th></th></tr></thead>
                  <tbody>
                    {commonItems.map(b => (
                      <tr key={b.id}>
                        <td><span className="badge badge-info" style={{fontSize:'0.72rem'}}>{b.category_name || 'عام'}</span></td>
                        <td className="font-bold">{b.material_name}{b.brand && b.brand!=='-'?' | '+b.brand:''}{b.size?' | '+b.size:''}</td>
                        <td><span className="badge badge-primary">{b.quantity_per_unit} {b.material_unit}</span></td>
                        <td><span className={`badge ${b.current_qty > 0 ? 'badge-success' : 'badge-danger'}`}>{b.current_qty}</span></td>
                        <td className="text-muted">{b.notes || '-'}</td>
                        <td><button className="btn btn-sm btn-danger" onClick={() => deleteBOMItem(b.id)}>✕</button></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>

            {/* المواد حسب الرائحة */}
            {Object.entries(flavorGroups).map(([flavorName, items]) => (
              <div key={flavorName} className="card mb-2">
                <div className="flex-between">
                  <div className="card-title">رائحة: {flavorName}</div>
                  {user?.role==='admin' && (
                    <button className="btn btn-sm btn-danger" onClick={() => deleteFullBOM(items[0]?.flavor_id)} title="حذف وصفة هذه الرائحة كاملة">🗑️ حذف الوصفة</button>
                  )}
                </div>
                <table>
                  <thead><tr><th>التصنيف</th><th>المادة</th><th>الكمية لكل وحدة</th><th>متوفر</th><th>ملاحظات</th><th></th></tr></thead>
                  <tbody>
                    {items.map(b => (
                      <tr key={b.id}>
                        <td><span className="badge badge-info" style={{fontSize:'0.72rem'}}>{b.category_name || 'عام'}</span></td>
                        <td className="font-bold">{b.material_name}{b.brand && b.brand!=='-'?' | '+b.brand:''}{b.size?' | '+b.size:''}</td>
                        <td><span className="badge badge-warning">{b.quantity_per_unit} {b.material_unit}</span></td>
                        <td><span className={`badge ${b.current_qty > 0 ? 'badge-success' : 'badge-danger'}`}>{b.current_qty}</span></td>
                        <td className="text-muted">{b.notes || '-'}</td>
                        <td><button className="btn btn-sm btn-danger" onClick={() => deleteBOMItem(b.id)}>✕</button></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}

            {bomItems.length === 0 && (
              <div className="card text-center" style={{ padding: 32 }}>
                <div style={{ fontSize: '2.5rem', marginBottom: 8 }}>⚗️</div>
                <p className="text-muted">لم تُضف مواد للوصفة بعد</p>
                <button className="btn btn-primary mt-2" onClick={() => setBomModal(true)}>+ ابدأ بإضافة المواد</button>
              </div>
            )}
          </div>
        )}

        {!selectedFP && finishedProducts.length > 0 && (
          <div className="card flex-center" style={{ padding: 48, flexDirection: 'column', gap: 12 }}>
            <div style={{ fontSize: '3rem' }}>👈</div>
            <p className="text-muted">اختر منتجاً من القائمة لتعديل وصفته</p>
          </div>
        )}
      </div>
    </div>
  );
}
